import { render, staticRenderFns } from "./HuashuReview.vue?vue&type=template&id=557256ba&scoped=true"
import script from "./HuashuReview.vue?vue&type=script&lang=js"
export * from "./HuashuReview.vue?vue&type=script&lang=js"
import style0 from "./HuashuReview.vue?vue&type=style&index=0&id=557256ba&prod&lang=css"
import style1 from "./HuashuReview.vue?vue&type=style&index=1&id=557256ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557256ba",
  null
  
)

export default component.exports